module.exports = __webpack_public_path__ + "img/ciaz-color.fcb917eb.svg";